import { lazy } from 'react'
import { Navigate, Outlet } from 'react-router'

import loadable from '@/ui-component/Loadable'

import { urls } from '@/utils/constants/urls'

// Auth
const Activation = loadable(lazy(() => import('@/pages/auth/activation')))
const Login = loadable(lazy(() => import('@/pages/auth/login')))
const Register = loadable(lazy(() => import('@/pages/auth/register')))
const ResetPassword = loadable(
    lazy(() => import('@/pages/auth/reset-password')),
)

// User
const Consume = loadable(lazy(() => import('@/pages/user/consume')))
const Profile = loadable(lazy(() => import('@/pages/account')))

const Homepage = loadable(lazy(() => import('@/pages/index')))

// Products
const ProductList = loadable(lazy(() => import('@/pages/catalogue/products')))
const ProductDetails = loadable(
    lazy(() => import('@/pages/catalogue/products/[id]')),
)

// Orders
const OrderList = loadable(lazy(() => import('@/pages/orders/index')))
const OrderDetails = loadable(lazy(() => import('@/pages/orders/[id]')))

const Cart = loadable(lazy(() => import('@/pages/cart')))

const PurchaseDetails = loadable(lazy(() => import('@/pages/purchases/[id]')))
const Refill = loadable(lazy(() => import('@/pages/refill')))
const Refills = loadable(lazy(() => import('@/pages/refills')))
const Stocks = loadable(lazy(() => import('@/pages/stocks')))
const DisputeList = loadable(lazy(() => import('@/pages/disputes/index')))
const DisputeDetails = loadable(lazy(() => import('@/pages/disputes/[id]')))

// Policies
const TermsOfService = loadable(lazy(() => import('@/pages/terms-of-service')))

export const router = (isLogged: boolean) => [
    {
        path: ':clientName',
        element: <Outlet />,
        children: [
            {
                path: 'auth/activation',
                element: <Activation />,
            },
            {
                path: 'auth/login',
                element: <Login />,
            },
            {
                path: 'auth/register',
                element: <Register />,
            },
            {
                path: 'auth/reset-password',
                element: <ResetPassword />,
            },

            // Products
            {
                path: 'catalogue/products',
                element: <ProductList />,
            },
            {
                path: 'catalogue/products/:id',
                element: <ProductDetails />,
            },

            // Orders
            {
                path: 'orders/:id',
                element: <OrderDetails />,
            },
            {
                path: 'orders',
                element: <OrderList />,
            },

            // Cart
            {
                path: 'cart',
                element: <Cart />,
            },
        ],
    },
    {
        path: ':clientName',
        element: isLogged ? <Outlet /> : <Navigate to='auth/login' />,

        children: [
            {
                path: '',
                element: <Homepage />,
            },
            {
                path: 'cart',
                element: <Cart />,
            },
            {
                path: 'user/consume',
                element: <Consume />,
            },
            {
                path: 'refills',
                element: <Refills />,
            },

            // Disputes
            {
                path: 'disputes',
                element: <DisputeList />,
            },
            {
                path: 'dispute/:id',
                element: <DisputeDetails />,
            },

            // Products
            {
                path: 'catalogue/products',
                element: <ProductList />,
            },
            {
                path: 'catalogue/products/:id',
                element: <ProductDetails />,
            },

            // Orders
            {
                path: 'orders',
                element: <OrderList />,
            },
            {
                path: 'orders/:id',
                element: <OrderDetails />,
            },

            {
                path: 'stocks',
                element: <Stocks />,
            },
            {
                path: 'refill',
                element: <Refill />,
            },
            {
                path: 'account',
                element: <Profile />,
            },
            {
                path: 'purchases/:id',
                element: <PurchaseDetails />,
            },
            {
                path: 'terms-of-service',
                element: <TermsOfService />,
            },
            {
                path: '*',
                element: isLogged ? (
                    <Navigate to='' />
                ) : (
                    <Navigate to={urls.auth.LOGIN} />
                ),
            },
        ],
    },
    {
        path: '/',
        element: <Outlet />,
        children: [
            {
                path: 'auth/login',
                element: <Login />,
            },
            {
                path: '',
                element: <Navigate to={urls.auth.LOGIN} />,
            },
        ],
    },
]
